import I18n from 'I18n';
import CRMPropertyValueTypes from 'automation-ui-flow-core/fields/CRMPropertyValueTypes';
export const getTargetPropertyValueLabel = ({
  dataTokenLabelsMap,
  omitQuotes,
  property,
  propertyValue = null
}) => {
  if (!property) {
    return propertyValue;
  }
  switch (property.type) {
    case CRMPropertyValueTypes.DATE:
      // Note: parseInt(null, 10) -> NaN, whereas Number(null) -> 0
      return I18n.moment.utc(parseInt(propertyValue, 10)).format('ll');
    case CRMPropertyValueTypes.DATETIME:
      return I18n.moment.userTz(parseInt(propertyValue, 10)).format('ll');
    case CRMPropertyValueTypes.ENUM:
      {
        if (!Array.isArray(property.options) || !propertyValue || !(typeof propertyValue === 'string')) {
          return propertyValue;
        }
        const propertyValues = propertyValue.split(';');
        const label = I18n.formatList(propertyValues.map(pValue => {
          if (dataTokenLabelsMap && dataTokenLabelsMap.has(pValue)) {
            return {
              label: dataTokenLabelsMap.get(pValue)
            };
          }
          return property.options.find(({
            value
          }) => value === pValue);
        }).filter(option => !!option).map(option => option.label));
        if (!label) {
          return propertyValue;
        } else {
          return label;
        }
      }
    case CRMPropertyValueTypes.STRING:
      return omitQuotes ? propertyValue : `"${propertyValue}"`;
    default:
      return propertyValue;
  }
};